// extracted by mini-css-extract-plugin
export var circle = "_g7-1";
export var exitConfirmationModal = "_g7-5";
export var iframe = "_g7-0";
export var offline = "_g7-3";
export var online = "_g7-2";
export var workstationSelectError = "_g7-4";